.kdx-faq {
	background: $faqBackgroundColor;
	box-shadow: $faqBoxShadow;
	border-radius: 6px;
	overflow: hidden;
	margin: 15px 0;
	transition: transform 350ms;
		
	&:hover, &:focus, &.hover {		
		box-shadow: $faqBoxShadowHover;
		
		.accordion-trigger {
			color: $faqTitleHoverColor; 			
		}
		.icon {
			transform: rotate(90deg);
		}
	}
	.accordion-trigger {
		padding: 20px;
		margin: 0;
		width: 100%;
		@include text-size(18);
		@include line-height(24);
		font-weight: 600;
		text-align: left;
		color: $faqTitleColor;
		user-select: none;
		display: flex;
		align-items: center;
		transition: all 350ms;
		background: none;
		outline: none;
		border: none;
		

		.icon {
			display: inline-block;
			transition: transform 350ms;
			margin-right: 10px;
		}

		svg {
			@include svg-format(10px, 21px, currentColor);
			transform: translateY(-2px);
		}
	}

	.kdx-faq-content {
		max-height: 0;
		overflow: hidden;
		transition: max-height 650ms;
		@include line-height(26);
	}

	.kdx-faq-content-inner {
		padding: 0px 20px 30px 60px;

		p { padding-bottom: 20px; }

		h4 { margin-bottom: 20px; }

		ul li {
			&:last-child { padding-bottom: 10px !important; }
		}
	}

	&.open {
		color: $faqTitleHoverColor;
		outline: none;
		box-shadow: $faqBoxShadowHover;
		
		.accordion-trigger {
			color: $faqTitleHoverColor;

			.icon {
				transform: rotate(90deg);
			}
		}

		.kdx-faq-content {
			max-height: 100%;
		}
	}

	&:hover {
		transform: translateY(-5px);
	}

}





@include media-breakpoint-down(md) {
	.kdx-faq {
		.accordion-trigger {			
			@include text-size(15);
			@include line-height(19);
			padding: 18px 20px 18px 20px;

			svg {
				@include svg-format(8px, 15px, currentColor);
				transform: translateY(0px);
			}
		}
		
		.kdx-faq-content-inner {
			padding: 0px 20px 20px 38px;
		}
	}
}
